export const isLoading = (query: { isLoading: boolean }): boolean =>
    query.isLoading;
export const isIdle = (query: { fetchStatus: string }): boolean =>
    query.fetchStatus === "idle";
